export default {
    methods: {
        newPerson() {
            return {
                name_given: null,
                name_family: null,
                phone_default: {
                    free_form_number: null,
                    default: true,
                    type: 'MOBILE'
                }
            }
        },
        newQueryGroup() {
            return {
                archived: false,
                description: null,
                important: false,
                name: null,
                query: {
                    exceptions: [],
                    queries: []
                }
            }
        },
        newStaticGroup() {
            return {
                archived: false,
                description: null,
                important: false,
                name: null,
                persons_ids: [],
                persons: []
            }
        }
    }
}
